import React from 'react';
import styles from './Footer.module.scss';
import { Link } from 'react-router-dom';

const Footer = props => {
  return (
    <footer className={styles.lowerFooter}>
      <div className={`container`}>
        <div className={`row`}>
          <div className={`col-12`}>
            <p className={styles.acknowledgment}>
              We pay respect to the Traditional Owners of country throughout Australia, and
              acknowledge their continued connection to land, waters, culture and community.
            </p>
            <hr />
            <ul className={`list-unstyled ${styles.desktop}`}>
              <li>
                <a href={'https://www.nsw.gov.au/accessibility-statement'} target={'_blank'}>
                  Accessibility
                </a>
              </li>
              <li>
                <a href={'https://www.customerservice.nsw.gov.au/copyright'} target={'_blank'}>
                  Copyright
                </a>
              </li>
              <li>
                <a href={'https://www.customerservice.nsw.gov.au/disclaimer'} target={'_blank'}>
                  Disclaimer
                </a>
              </li>
              <li>
                <Link to={'/privacy'}>Privacy</Link>
              </li>
              <li>
                <Link to={'/join-service'}>Join the service</Link>
              </li>
              <li>
                <Link to={'/about'}>About</Link>
              </li>
              <li>
                <Link to={'/contact-us'}>Contact us</Link>
              </li>
            </ul>
            <p className={styles.copyright}>Copyright © 2021 NSW Department of Customer Service</p>
            <div className={styles.mobile}>
              <ul className={`list-unstyled`}>
                <li>
                  <a href={'https://www.nsw.gov.au/accessibility-statement'} target={'_blank'}>
                    Accessibility
                  </a>
                </li>
                <li>
                  <a href={'https://www.customerservice.nsw.gov.au/copyright'} target={'_blank'}>
                    Copyright
                  </a>
                </li>
                <li>
                  <a href={'https://www.customerservice.nsw.gov.au/disclaimer'} target={'_blank'}>
                    Disclaimer
                  </a>
                </li>
                <li>
                  <Link to={'/contact-us'}>Contact us</Link>
                </li>
              </ul>
              <ul>
                <li>
                  <Link to={'/privacy'}>Privacy</Link>
                </li>
                <li>
                  <Link to={'/join-service'}>Join the service</Link>
                </li>
                <li>
                  <Link to={'/about'}>About</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
